import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
    pageMaxWidth: (props) => ({
        width: props.maxWidth
    }),
    modalInternalGrid: {
        backgroundColor: "#fff",
        width: "50%",
        margin: "0 auto",
        marginTop: "100px",
        border: "2px solid black"
    },
    modal: {
        overflowY: "scroll"
    }
}), { name: "DployFormFullWidth" });
//# sourceMappingURL=styles.js.map